import { ERequestApiStatus, EWsClientEventType } from '../../types/appState';
import { ITypedReduxAction } from '../../types/redux/actionType';

export enum EWsSessionActionTypes {
  SetWsRegistration = 'chats/wsSession/setWsRegistration',
}

export type TWsSessionActions = ITypedReduxAction<EWsSessionActionTypes.SetWsRegistration, string>;

export interface ISessionEvent {
  type: EWsClientEventType.Session;
  status: ERequestApiStatus;
}

export interface IWsSessionEvent {
  uid: string;
  sessionToken: string;
  userId: number;
  type: EWsClientEventType.Session;
}
